// Kept out of Sidebar.tsx so the active nav item is derived from the route on
// every render instead of being cached in state. Deriving it here means
// browser Back/Forward, deep links and redirects all stay in sync for free,
// and the mapping is plain enough to unit test on its own.

export type NavItem = "meetings" | "chat" | "calendar" | "webinar" | "analytics" | "marketplace" | "rooms" | "settings"

export function navActiveItem(pathname: string): NavItem {
  const path = pathname
  if (path.includes('/chats')) return 'chat'
  if (path.includes('/calendar')) return 'calendar'
  if (path.includes('/webinar')) return 'webinar'
  if (path.includes('/analytics')) return 'analytics'
  if (path.includes('/market') || path.includes('/marketplace') || path.includes('/myapps')) return 'marketplace'
  if (path.includes('/rooms')) return 'rooms'
  if (path.includes('/settings') || path.includes('/account-settings')) return 'settings'
  if (path === '/meetings' || path === '/Meetings' || path.includes('/Meetings')) return 'meetings'
  return 'meetings'
}
